import InternalBookingPage from "@components/InternalBookingPage";
import { useDataStore } from "@store/user_org";
import { isOwnerOrAdmin } from "@utils/permissions";

export default function NouveauRDVModal({ onClose, onSuccess }: { onClose: () => void; onSuccess?: () => void }) {
  const userData = useDataStore((s) => s.userData);
  const manager = isOwnerOrAdmin(userData);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: "rgba(0,0,0,0.4)" }}
    >
      <InternalBookingPage
        onClose={onClose}
        onSuccess={onSuccess}
        internalMode
        isManager={manager}
      />
    </div>
  );
}
